import type { CarouselItem, UploadingCarouselItem } from './types';
import { isUploadedCarouselItem } from './types';

const MAX_PREVIEW_COUNT = 2;

/**
 * Creates a function that determines which images should display previews during upload.
 *
 * Due to browser performance issues, we limit preview rendering to only the first
 * few images that are being uploaded.
 *
 * The "ForDisplay" suffix indicates this is for UI rendering only and preserves
 * the original image identities in the data model.
 */
const generateGetImageForDisplay = (images: CarouselItem[]) => {
  const previewableItems = new Set<UploadingCarouselItem>();

  images.forEach((image) => {
    if (
      isUploadedCarouselItem(image) ||
      previewableItems.size >= MAX_PREVIEW_COUNT
    ) {
      return;
    }

    previewableItems.add(image);
  });

  return (image: CarouselItem): CarouselItem => {
    if (isUploadedCarouselItem(image) || previewableItems.has(image)) {
      return image;
    }
    const { uploadPreviewSource: _uploadPreviewSource, ...rest } = image;
    return rest;
  };
};

export default generateGetImageForDisplay;
